import { createApiRef } from '@backstage/core-plugin-api';
import {
  UptimeMetricRequest,
  UptimeMetricResponse,
  MonitorChecksHistoryResponse,
  UptimeMonitorRequest,
  UptimeMonitorResponse,
  Issue,
  IssuesRequest,
  IssuesListResponse,
  IssueDetailRequest,
  IssueEventLatestRequest,
  IssueEventDetails,
  IssueUpdateRequest,
  IssueUpdateResponse,
  StatusUpdateWithCommentRequest,
  Comment,
  IssueCommentsRequest,
  AddCommentRequest,
  UpdateCommentRequest,
  DeleteCommentRequest,
  TransactionGroupsRequest,
  TransactionGroupsListResponse,
  TransactionGroupDetailRequest,
  TransactionGroup,
  CreateTaskFromIssueRequest,
  GetAIPredictionRequest,
  AIPredictionResponse,
  GenerateAISuggestionRequest,
  AISuggestionResponse
} from '../types';

export const uptimeMonitorApiRef = createApiRef<UptimeMonitorAPI>({
  id: 'plugin.uptime-monitor.service',
});

export interface UptimeMonitorAPI {
  getHealthCheck(params: UptimeMonitorRequest): Promise<UptimeMonitorResponse>;
  triggerMonitorCheck(
    params: UptimeMonitorRequest,
  ): Promise<UptimeMonitorResponse>;
  getPaginatedMonitorChecksHistory(
    params: UptimeMonitorRequest,
  ): Promise<MonitorChecksHistoryResponse>;
  subscribeToHealthCheckUpdates(
    params: UptimeMonitorRequest,
    onUpdate: (data: UptimeMonitorResponse) => void,
    onError?: (error: Error) => void,
  ): Promise<() => void>;
  getUptimeMetrics(params: UptimeMetricRequest): Promise<UptimeMetricResponse>;
  getUptimeMonitor(params: UptimeMetricRequest): Promise<UptimeMonitorResponse>;
  getIssues(params: IssuesRequest): Promise<IssuesListResponse>;
  getIssueDetail(params: IssueDetailRequest): Promise<Issue>;
  getIssueEventLatest(params: IssueEventLatestRequest): Promise<IssueEventDetails>; 
  updateIssueStatus(params: IssueUpdateRequest): Promise<IssueUpdateResponse>;
  updateIssueStatusWithComment(params: StatusUpdateWithCommentRequest): Promise<IssueUpdateResponse>;
  getIssueComments(params: IssueCommentsRequest): Promise<Comment[]>;
  addIssueComment(params: AddCommentRequest): Promise<Comment>;
  updateIssueComment(params: UpdateCommentRequest): Promise<Comment>;
  deleteIssueComment(params: DeleteCommentRequest): Promise<void>;
  getTransactionGroups(params: TransactionGroupsRequest): Promise<TransactionGroupsListResponse>;
  getTransactionGroupDetail(params: TransactionGroupDetailRequest): Promise<TransactionGroup>;
  createTaskFromIssue?(params: CreateTaskFromIssueRequest): Promise<any>;

  // AI
  getAIPrediction(params: GetAIPredictionRequest): Promise<AIPredictionResponse | null>;
  generateAISuggestion(params: GenerateAISuggestionRequest): Promise<AISuggestionResponse>;
}
